<div class="appointment-card-wrapper">
  <div class="ui-g-12 appointment-card" [ngClass]="{ 'appointment-card': '!isPast', 'past-appointment-card': isPast }">
    <div class="ui-g-3 date-box py-2">
      <div class="appointment-month">
        <span class="appointment-date" [ngClass]="{ 'text-strike': appointment?.status === 'cancelled' }">{{ appointment?.month }} {{ appointment?.date }}</span>
      </div>
      <div class="appointment-time text-center">
        <span class="appointment-time" [ngClass]="{ 'text-strike': appointment?.status === 'cancelled' }">
          {{ appointment?.time }}
        </span>
      </div>
    </div>

    <div class="ui-g-9">
      <div class="ui-g-12 p-0 mb-2p">
        <div
          [id]="'appt-card-ispast-' + isPast + '-' + tab + index"
          class="font-bold font-12 estimate-name pointer text-truncate"
          [ngClass]="{ 'text-strike': appointment.status === 'cancelled' }"
          (click)="openAppointmentModal(appointment)"
        >
          {{ appointment?.title }} &nbsp;
          <i class="fal fa-check" *ngIf="appointment?.status === 'confirmed'"></i>
        </div>
      </div>

      <div class="ui-g-12 p-0">
        <div class="apt-lic-numb">
          {{ appointment?.vehicle?.licensePlateNo }}
        </div>
      </div>

      <div class="ui-g-12 p-0 mb-2p d-none">
        <div class="font-bold font-12 estimate-name" [ngClass]="{ 'text-strike': appointment?.status === 'cancelled' }">
          {{ appointment?.code }}
        </div>
      </div>

      <div class="ui-g-12 p-0 mb-2p">
        <div class="appointment-details text-truncate" [ngClass]="{ 'text-strike': appointment?.status === 'cancelled' }">
          {{ appointment?.vehicleName }}
        </div>
      </div>
    </div>
  </div>
</div>
